function init()
{
    var ifrm = document.createElement("iframe");
    ifrm.setAttribute('title', 'Mbid cookie-sync' );
    ifrm.setAttribute('sandbox', 'allow-scripts allow-same-origin');
    ifrm.setAttribute("src", "https://mbid.marfeelrev.com/static/cookie-sync.html");
    ifrm.style.width = "1px";
    ifrm.style.height = "1px";
    ifrm.style.display = 'none';

    $(function(){
        document.body.appendChild(ifrm);
    });
}

export default init;